module.exports = __webpack_public_path__ + "media/images/regional-image6-4d7c1c93707219ba910e98144afa89e5.jpg";